/**
 * Admin miniature for a Yatzy level.
 *
 * A level has no layout to draw: every level is the same 13-slot sheet, and its content is only
 * its tag (`hard`), optionally a preset sheet (`slots`, `score`, `bonus`, the tutorial level) and a `goal`
 * score. So the card is that data: the sheet in the game's slot art with the preset slots played
 * and their scores on them, the tag, and, on the maxiature, the remaining fields as text.
 */

AdminLevelMiniature.yatzyCard = function (adminLevel, styles) {
    const content = adminLevel.content || adminLevel;
    const slots = content.slots || {};
    // the tag the admin edits (migrated from content.hard), so the card follows a tag toggle
    const tag = adminLevel.getTag();

    const tiles = [];
    for (let id = 0; id < Yatzy.SLOTS_AMOUNT; id++) {
        tiles.push(AdminLevelMiniature.yatzySlot(id, slots[id]));
    }

    const rows = [];
    for (let start = 0; start < tiles.length; start += styles.columns) {
        rows.push(new cleverapps.Layout(tiles.slice(start, start + styles.columns), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        }));
    }

    const items = [
        cleverapps.UI.generateOnlyText((tag || "normal").toUpperCase(), Level.IsHardTag(tag) ? cleverapps.styles.FONTS.ADMIN_YATZY_HARD : cleverapps.styles.FONTS.ADMIN_YATZY_NORMAL),
        new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        })
    ];

    if (styles.details) {
        const used = Object.keys(slots).filter((id) => slots[id].used).length;
        const lines = [
            `free slots: ${Yatzy.SLOTS_AMOUNT - used}/${Yatzy.SLOTS_AMOUNT}`,
            `start score: ${content.score || 0}`,
            `upper bonus: ${content.bonus || 0}/${Yatzy.BONUS_GOAL}`,
            `goal: ${content.goal || "none (fill the sheet)"}`,
            `tutorial: ${content.tutorial || "none"}`
        ];
        items.push(cleverapps.UI.generateOnlyText(lines.join("\n"), cleverapps.styles.FONTS.ADMIN_YATZY_DETAILS));
    }

    return new cleverapps.Layout(items, {
        direction: cleverapps.UI.VERTICAL,
        margin: styles.margin
    });
};

// One slot of the sheet as the game draws it: the slot icon on its plate, and a played slot dimmed
// with its score on it, the way SlotView.animateConfirmation leaves it.
AdminLevelMiniature.yatzySlot = function (id, preset) {
    const plate = new cc.Sprite(bundles.slots.frames.slot_bg);
    const icon = new cc.Sprite(bundles.slots.frames[`slot_${id}`]);
    icon.setPosition(plate.width / 2, plate.height / 2);
    plate.addChild(icon);

    if (!preset || !preset.used) {
        return plate;
    }

    plate.setCascadeOpacityEnabled(true);
    plate.setOpacity(153);
    plate.setColor(cleverapps.styles.COLORS.COLOR_GRAY);
    icon.setColor(cleverapps.styles.COLORS.BLACK);
    icon.setOpacity(100);

    const tile = new cc.Node();
    tile.setAnchorPoint(0.5, 0.5);
    tile.setContentSize2(plate.width, plate.height);
    plate.setPosition(tile.width / 2, tile.height / 2);
    tile.addChild(plate);

    const score = new cleverapps.UI.ImageFont(preset.score || 0, cleverapps.styles.FONTS.SLOT_SCORE_PLAYED_TEXT);
    score.setPosition(tile.width / 2, tile.height / 2);
    tile.addChild(score);

    return tile;
};

AdminLevelMiniature.yatzy = function (adminLevel) {
    return AdminLevelMiniature.yatzyCard(adminLevel, cleverapps.styles.AdminLevelYatzyCard.miniature);
};

cleverapps.styles.AdminLevelYatzyCard = {
    miniature: {
        columns: 5,
        margin: 10,
        details: false
    },

    maxiature: {
        columns: 7,
        margin: 16,
        details: true
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ADMIN_YATZY_NORMAL: {
        size: 110,
        color: new cc.Color(46, 125, 50, 255)
    },

    ADMIN_YATZY_HARD: {
        size: 110,
        color: new cc.Color(211, 47, 47, 255)
    },

    ADMIN_YATZY_DETAILS: {
        size: 34,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    }
});
